import { render, staticRenderFns } from "./AndroidOrderIcon.vue?vue&type=template&id=13dd31a9&scoped=true"
import script from "./AndroidOrderIcon.vue?vue&type=script&lang=js"
export * from "./AndroidOrderIcon.vue?vue&type=script&lang=js"
import style0 from "./AndroidOrderIcon.vue?vue&type=style&index=0&id=13dd31a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dd31a9",
  null
  
)

export default component.exports